import React, { PureComponent, ReactNode } from "react";
import { AppContextType, MenuName } from "../../../AppContext";
import { ICON_PAUSE, ICON_PLAY } from "../../../constants/iconConstants";
import ChordInteractModeDropdown from "../../music_controls/custom_buttons/ChordInteractModeDropdown";
import HistoryAutoScrollButton from "../../music_controls/custom_buttons/HistoryAutoScrollButton";
import NoteVisibilityModeButton from "../../music_controls/custom_buttons/NoteVisibilityModeButton";
import OpenSettingsMenuButton from "../../music_controls/custom_buttons/OpenSettingsMenuButton";
import IconButton from "../../theme_reuse/IconButton";
import OpenTranscriptionPopupButton from "../../music_controls/custom_buttons/OpenTranscriptionPopupButton";

interface Props {
  onBeginReplay: () => void;
  onPauseReplay: () => void;
  onDownloadHistory: () => void;
  onUploadHistory: () => void; // FIXME: input
  isHistoryExist: boolean;
  isReplaying: boolean;
  isCaptureActive: boolean;
}
interface State {}

export default class HistoryMonitorHeader extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  uploadPriorHistory = () => {
    // FIXME: upload file/json prompt/window
    this.props.onUploadHistory();
  };

  downloadHistory = () => {
    this.props.onDownloadHistory();
  };

  beginReplayChords = () => {
    if (!this.props.isReplaying) {
      this.props.onBeginReplay();
    }
  };

  pauseReplayingChords = () => {
    if (this.props.isReplaying) {
      this.props.onPauseReplay();
    }
  };

  render(): ReactNode {
    const { isHistoryExist, isReplaying, isCaptureActive } = this.props;
    return (
      <div className="history-monitor-header-bar">
        {/* {!isHistoryExist && (
          <IconButton mini title="Upload Chords from a previous visit" icon={ICON_UPLOAD} onClick={this.uploadPriorHistory} />
        )}
        {!isCaptureActive && isHistoryExist && <IconButton mini title="Download" icon={ICON_DOWNLOAD} onClick={this.downloadHistory} />} */}
        {!isCaptureActive && isHistoryExist && !isReplaying && (
          <IconButton mini title="Replay Chords" icon={ICON_PLAY} onClick={this.beginReplayChords} />
        )}
        {!isCaptureActive && isHistoryExist && isReplaying && (
          <IconButton mini title="Pause Chords" icon={ICON_PAUSE} onClick={this.pauseReplayingChords} />
        )}
        {!isCaptureActive && isHistoryExist && <OpenTranscriptionPopupButton />}
        <ChordInteractModeDropdown />
        <NoteVisibilityModeButton />
        <HistoryAutoScrollButton />
        <OpenSettingsMenuButton menuName={MenuName.ChordHistoryOptions} />
        {/* <OpenHelpPopupButton helpPageName={HelpPageName.ChordControls} /> */}
      </div>
    );
  }
}

HistoryMonitorHeader.contextType = AppContextType;
